<div class="name">{{role?.name}}</div>
<div (click)="removeRoleEvent.emit()" pRipple class="button red remove action" *ngIf="isEditMode"><div class="ficon ficon-Delete icon-only"></div></div>
